function getArrayHash(arr, fileds) {
    if (!arr) return '';
    return arr.map((el) => {
        var res = '';

        for (var i = 0; i < fileds.length; i++) {
            res += el[fileds[i]];
        }
        return res;
    }).join('');
}

export default getArrayHash;
